import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { accountTranslations } from '../helpers/translations'
const TOTAL_STEPS = Object.keys(ON_BOARDING_STATES)?.length - 1 ?? 5
const SECTION_TITLES = [
  '',
  accountTranslations.onboarding.step_1.title,
  accountTranslations.onboarding.step_2.title,
  accountTranslations.onboarding.step_3.title,
  accountTranslations.onboarding.step_4.title,
  accountTranslations.onboarding.step_5.title
]

const getSectionTitle = (step, name) => {
  return SECTION_TITLES[step].replace('{name}', name)
}

const ProgressBar = ({ currentPosition }) => {
  if (currentPosition === ON_BOARDING_STATES.INIT) return <></>

  return (
    <div className={'flex min-w-96 flex-col gap-4 px-6 md:px-20'}>
      <div className={'paragraph-sm text-center text-neutrals-secondary-grey'}>
        Step {currentPosition} of {TOTAL_STEPS}
      </div>
      <div className={'relative h-2 w-full rounded-md bg-neutrals-image-grey'}>
        <div
          style={`--percent-w:${parseInt(currentPosition * 20)}%;`}
          className={'absolute left-0 top-0 h-full w-[--percent-w] rounded-md bg-primary-black'}
        ></div>
      </div>
    </div>
  )
}

export function OnBoardingHeader() {
  const context = useMobileFiltersContext()
  const { currentState } = context.config
  const childName = context.getCurrentChild().steps[0]?.firstName ?? 'Child'
  const isFirstStep = currentState === ON_BOARDING_STATES.INIT

  if (isFirstStep) return <></>

  return (
    <div className={''}>
      <div className={'flex flex-col items-center justify-center gap-6'}>
        <ProgressBar currentPosition={currentState} />
        <h2 className={'h2 px-6 md:px-20'}>{getSectionTitle(currentState, childName)}</h2>
      </div>
      {<div className={'my-8 border border-solid border-neutrals-secondary-grey opacity-50'}></div>}
    </div>
  )
}
